<template>
  <li>
    <slot></slot>
    <b-button
      block
      v-on="name == 'Sign Out' ? { click: () => clear()} : ''"
      v-b-toggle="'collapse-' + index"
      variant="transparent"
      class="text-white d-flex position-relative align-items-center py-4"
      :class="{
        'dropdown-toggle': dropdown,
        'disabled': disabled,
      }"
      :to="dropdown ? '' : href"
      style="box-shadow: none;"
    >
      <b-icon :icon="icon" class="mx-2"></b-icon>
      <span class="ml-4 mr-2 flex-grow-1 text-left text-nowrap">{{ name }}</span>
    </b-button>
    <b-collapse
      :id="'collapse-' + index"
      v-model="collapse"
      accordion="nav-accordion"
      v-if="dropdown"
    >
      <ul class="list-unstyled text-gray-200">
        <li
          v-for="(subNav, subIdx) in subNavigation"
          :key="subIdx"
          class="py-1"
          style="width: 240px; padding-left: 62px;"
        >
          <router-link
            :to="subNav.href"
            class="btn-link"
            :class="{
              disabled: subNav.hasOwnProperty('disabled') ? subNav.disabled : false
            }"
          >{{ subNav.name }}</router-link>
        </li>
      </ul>
    </b-collapse>
  </li>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    dropdown: Boolean,
    index: Number,
    href: String,
    icon: String,
    name: String,
    subNavigation: Array,
    disabled: Boolean,
  },
  data() {
    return {
      collapse: false,
    };
  },
  methods: {
    clear() {
      this.$store.commit('deAuthenticate');
    },
  },
};
</script>

<style scoped>

</style>
